import { useAppDispatch, useAppSelector } from '@verantos-dev/app-state-base';
import {
  DerivedEventInputFieldTypeLegacy,
  DerivedEventTypeLegacy,
} from '@verantos-dev/types-cohorts';

import {
  addActiveCohortBuilderEventForDerivedEventType,
  setActiveCohortBuilderEventInputFieldValue,
  deleteActiveCohortBuilderEvent,
} from '../cohortBuilderSlice';
import {
  selectActiveCohortBuilderItemEventFilters,
  selectActiveCohortBuilderItemType,
} from '../selectors/cohortBuilderEditModalSelectors';

export const useCohortBuilderEvents = () => {
  const dispatch = useAppDispatch();
  const activeDerivedEventType = useAppSelector(selectActiveCohortBuilderItemType) as
    | DerivedEventTypeLegacy
    | undefined;
  const eventFilters = useAppSelector(selectActiveCohortBuilderItemEventFilters) ?? [];

  const onAddCohortBuilderEventClick = () => {
    activeDerivedEventType &&
      dispatch(addActiveCohortBuilderEventForDerivedEventType(activeDerivedEventType));
  };

  const onEditCohortBuilderEventInputFieldValue = (
    derivedEventFilterId: string,
    derivedEventFieldType: DerivedEventInputFieldTypeLegacy,
    value: string
  ) => {
    activeDerivedEventType &&
      dispatch(
        setActiveCohortBuilderEventInputFieldValue({
          derivedEventFilterId,
          derivedEventType: activeDerivedEventType,
          derivedEventFieldType,
          value,
        })
      );
  };

  const onDeleteCohortBuilderEventClick = (id: string) => {
    dispatch(deleteActiveCohortBuilderEvent(id));
  };

  return {
    eventFilters,
    onAddCohortBuilderEventClick,
    onEditCohortBuilderEventInputFieldValue,
    onDeleteCohortBuilderEventClick:
      activeDerivedEventType !== DerivedEventTypeLegacy.INSTANCE
        ? onDeleteCohortBuilderEventClick
        : undefined,
  };
};
